import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { getStripeAccountSetup } from "../../../_redux/dashboard/dashboardActions";
import Spinner from "components/UI/Spinner.js";
import toastHandler from "components/UI/toastHandler/toastHandler";

export default function SessionExpiredModal({
  show,
  onHide,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const handleConnectWithStripe = () => {
    setIsLoading(true);
    dispatch(
      getStripeAccountSetup(
        (response) => {
          setIsLoading(false);
          if (response.data.url) {
            window.location.href = response.data.url;
          } else if (response.data && response.status === true && response.message) {
            toastHandler(response.message, "success");
            onHide();
          }
        },
        (error) => {
          setIsLoading(false);
          toastHandler(error || "An error occurred while connecting with Stripe", "error");
        }
      )
    );
  };

  const handleClose = () => {
    onHide();
    history.push("/my-profile/payments");
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      aria-labelledby="example-modal-sizes-title-lg"
      centered
      backdrop="static"
      keyboard={false}
      size="md"
    >
      <Modal.Header style={{
          borderBottom: "1px solid gray !important"
        }} bordered>
        <Modal.Title id="example-modal-sizes-title-lg">Session Expired</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Your onboarding session has expired.</p>
      </Modal.Body>
      <Modal.Footer>
        <button 
          type="button" 
          className="btn btn-outline-secondary px-3 border-fifth me-2" 
          onClick={handleClose}
          disabled={isLoading}
        >
          CANCEL
        </button>
        <button 
          type="button" 
          className="btn btn-primary text-white" 
          onClick={handleConnectWithStripe}
          disabled={isLoading}
        >
          {isLoading ? <Spinner /> : "TRY AGAIN"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
